import React, { useEffect, useState } from 'react';
import { ApolloClient, InMemoryCache, ApolloProvider, ApolloLink, createHttpLink, TypePolicies } from '@apollo/client';
import { createAuthLink, AuthOptions, AUTH_TYPE } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
// import config from '../graphql/amplify_outputs.json';
import configDev from '../graphql/amplify_outputs_dev_sandbox.json';
import configProd from '../graphql/amplify_outputs_prod.json';
import { fetchAuthSession } from 'aws-amplify/auth';
import Spinner from 'react-bootstrap/Spinner';

const env = process.env.REACT_APP_ENV;
const config = env === "prod" ? configProd : configDev;

interface IClient {
    children: React.ReactNode;
    mobileClient?: any | null;
}

const url = config.data.url;
const region = config.data.aws_region;

const mergeLists = (existing: { items: any[] } = { items: [] }, incoming: { items: any[] } = { items: [] }) => ({
    ...existing,
    ...incoming,
    items: [...(existing?.items || []), ...incoming.items],
});

const typePolicies: TypePolicies = {
    Query: {
        fields: {
            postByDate: {
                keyArgs: ['type', 'filter', 'createdAt', 'sortDirection'],
                merge: mergeLists,
            },
            commentsByPost: {
                keyArgs: ['postID', 'filter', 'createdAt', 'sortDirection'],
                merge: mergeLists,
            },
        },
    },
};

const Client: React.FC<IClient> = ({ children, mobileClient }) => {
    const [client, setClient] = useState<ApolloClient<any> | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const setupClient = async () => {
            try {
                // Récupérer le token JWT
                const { tokens } = await fetchAuthSession({ forceRefresh: true });
                // console.log('TOKENS', tokens)
                
                let jwtToken
                if (mobileClient && mobileClient != "null") {
                    jwtToken = mobileClient.toString();
                } else {
                    jwtToken = tokens?.idToken?.toString();
                }
                // alert('AAAAAA' + jwtToken);
                // console.log(JSON.stringify(jwtToken));

                if (!jwtToken) throw new Error('JWT token not available');

                // Configurer l'authentification Apollo
                const auth: AuthOptions = {
                    type: config.data.default_authorization_type as unknown as AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
                    jwtToken: jwtToken,
                };

                const httpLink = createHttpLink({ uri: url });
                // alert('http'+ JSON.stringify(httpLink));
                const link = ApolloLink.from([
                    createAuthLink({ url, region, auth }),
                    createSubscriptionHandshakeLink({ url, region, auth }, httpLink),
                ]);
                // alert('link'+JSON.stringify(link));
                // Créer le client Apollo
                const apolloClient = new ApolloClient({
                    link,
                    cache: new InMemoryCache({ typePolicies }),
                });

                setClient(apolloClient);
            } catch (error) {
                console.error('Error setting up Apollo Client:', error);
            } finally {
                setLoading(false);
            }
        };

        setupClient();
    }, []);

    // useEffect(() => {
    //     // alert('alert' + client);
    //     console.log(client);
    // }, [client]);

    if (loading) {
        return (
            <div></div>
            // <Spinner animation="border" role="status">
            //     <span className="visually-hidden">Loading...</span>
            // </Spinner>
        );
    }

    if (!client) {
        return <div>Error initializing Apollo Client.</div>;
    }

    return (
        <ApolloProvider client={client}>
            {children}
        </ApolloProvider>
    )
};

export default Client;
